module.exports = __webpack_public_path__ + "static/turquia-012.thumb-c91e40b98a3fa0c6f06107ac2e5d9432.jpg";